import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}

export default {
name: 'myOrder',
directives: {
TransferDom
},
components: {
XHeader,
CheckIcon,
Group,
XButton,
Tab,
TabItem,
Scroller,
Confirm,
Actionsheet,
Popup,
Datetime
},
data () {
return {
list: [],
page: 1,
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
noData: false,
orderStatus: '9999',
searchContent: '',
showConfirm: false,
confirmText: '',
cancelText: '',
confirmImg: '',
confirmContent: '',
confirmEvent: '',
activeIndex: '',
activeItem: '',
showSupplementalInvoice: false,
supplementalInvoiceMenus: {
single: '补开此订单发票',
withOthers: '和其它订单一起补开发票',
},
showInvoiceOrderList: false,
invoiceOrderList: [],
startTime: '',
endTime: '',
invoiceOrderNum: '',
selectedItem: '',
selectedOrderCode: '',
isNotReceiveTheGoods: false,
showConfirmReceipt: false,
notReceiveTheGoodsCode: '',
showReason: false,
}
},
methods: {
fileLinkToStreamDownload(url, name) {
document.getElementById("downloadForm") .setAttribute("action",  baseURL + "/file/download");
document.getElementById("filePath").value = url;
document.getElementById("newFileName").value = name;
document.getElementById("token").value = this.getCookie();
document.getElementById("downloadForm").submit();
},
xz(item){


let name=item.einvoicePath.split('/')[2]


if(name=='hlh-shopping-image.oss-cn-shenzhen.aliyuncs.com'){
this.fileLinkToStreamDownload(item.einvoicePath,'电子票.pdf')
}else{
const a = document.createElement("a");
a.href = item.einvoicePath+'?pdfjs.action=print_preview';
a.download = 'xxxx';
document.body.appendChild(a);
a.click();
a.remove();

}





},
fetchData(cb) {
this.$request.post('/order/myOrderList',{
page: this.page,
rows: 10,
token: this.$token,
obj: {
orderStatus: this.orderStatus,  //  0：待付款  1：待收货  2：已完成  3：已取消  9999：全部
searchContent: this.searchContent,
searchTime: '9999'  
}
}).then(data => {
if(data.code == 0){
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
cb(data.obj.rows)
console.log(data)
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()




console.log(e)
})
},
refresh() {
this.page = 1
this.fetchData(data => {
this.list = data
this.list.forEach((item, index) => {
let qty = 0
item.orderDetails.forEach((item2, index2) => {
qty += item2.qty
})
item.qty = qty
})
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
console.log('下拉刷新成功')
})
this.page += 1
},
loadMore() {
this.fetchData(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.list = this.list.concat(data)
this.list.forEach((item, index) => {
let qty = 0
item.orderDetails.forEach((item2, index2) => {
qty += item2.qty
})
item.qty = qty
})
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
},
search () {
this.$vux.loading.show({
text: ''
})

this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1

this.loadMore()
},
commodity (item, index) {
this.$router.push({
path: '/commodity',
query: {
id: item.spuId
}
})
},
allOrders () {  //全部订单






this.$vux.loading.show({
text: ''
})
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.orderStatus = '9999'
this.loadMore()
},
obligationOrders () {  //待付款






this.$vux.loading.show({
text: ''
})
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.orderStatus = '0'
this.loadMore()
},
waitForReceivingOrders () {  //待收货






this.$vux.loading.show({
text: ''
})
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.orderStatus = '1'
this.loadMore()
},
completedOrders () {  //已完成






this.$vux.loading.show({
text: ''
})
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.orderStatus = '2'
this.loadMore()
},
canceledOrders () {  //已取消






this.$vux.loading.show({
text: ''
})
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.orderStatus = '3'
this.loadMore()
},

payNow (item, index) {    //立即付款
if(item.orderType == "商城"){
for(let i=0; i<item.orderDetails.length; i++){
if(item.orderDetails[i].soldStatus != '上架'){
this.$vux.toast.show({
type: 'warn',
text: item.orderDetails[i].spuName+' 已下架'
})
return false;
}
}
}
if(item.orderUnionCode != null){
this.$router.push({
path: '/submitOrderSuccess',
query: {
orderNumber: item.orderUnionCode
}
})
}else{
this.$router.push({
path: '/submitOrderSuccess',
query: {
orderNumber: item.orderCode
}
})
}
},
checkReason (item, index) {  //查看原因
this.activeItem = []
for(let i=0; i<item.transferAccountsMsg.split('_@_').length; i++){
if(i < item.transferAccountsMsg.split('_@_').length-1){
this.activeItem.push(item.transferAccountsMsg.split('_@_')[i])
}
}

this.showReason = true
},
buyAgain (item, index) {  //再次购买
if(item.orderType == "商城"){
for(let i=0; i<item.orderDetails.length; i++){
if(item.orderDetails[i].soldStatus != '上架'){
this.$vux.toast.show({
type: 'warn',
text: item.orderDetails[i].spuName+' 已下架'
})
return false;
}
}
}
this.$request.post('/order/buyagain',{
orderId: item.orderId,
token: this.$token,
}).then(data => {
if(data.code == 0){
if(item.orderUnionCode != null){
this.$router.push({
path: '/submitOrderSuccess',
query: {
orderNumber: item.orderUnionCode
}
})
}else{
this.$router.push({
path: '/submitOrderSuccess',
query: {
orderNumber: item.orderCode
}
})
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
cancelOrder (item, index) {   //取消订单
this.showConfirm = true
this.confirmEvent = 'cancelOrder'
this.confirmText = '确定'
this.cancelText = '再想想'
this.confirmImg = require('../../assets/images/redWarn.png')
if(item.orderUnionCode != null){
let codeList = ''
this.getOthersOrder(item.orderUnionCode,data => {
data.forEach((item, index) => {
codeList += item.orderCode + '，'
})
this.confirmContent = `该订单存在合并订单，订单 ${codeList} 将会一起取消。确定要取消吗?`
})
}else{
this.confirmContent = '确定取消该订单吗？'
}
this.activeIndex = index
this.activeItem = item
},
applicationForDrawback (item, index) {   //申请退款
this.showConfirm = true
this.confirmEvent = 'applicationForDrawback'
this.cancelText = '再想想'
this.confirmText = '确定'
this.confirmImg = require('../../assets/images/redWarn.png')
if(item.orderUnionCode != null){
let codeList = '',
cantRefundId = '';
this.getOthersOrder(item.orderUnionCode,data => {
data.forEach((item, index) => {
codeList += item.orderCode + '，'
if(item.orderStatus > 150){
cantRefundId += item.orderCode + '，'
}
})
if(cantRefundId == ''){
this.confirmContent = `该订单存在合并订单，订单 ${codeList} 将会一起退款。确定要退款吗?`
}else{
this.confirmContent = `该订单存在合并订单，订单 ${cantRefundId} 已进行其他工序，无法退款`
this.confirmEvent = 'applicationForDrawbackCantRefund'
this.cancelText = '关闭'
}
})
}else{
this.confirmContent = '确定申请退款吗？'
}
this.activeIndex = index
this.activeItem = item
},
showConfirmReceiptDialog (item, index) {
this.activeIndex = index
this.activeItem = item
this.showConfirmReceipt = true
},
confirmReceipt () {   //确认收货
this.$request.post('/order/confirmReceive',{
orderId: this.activeItem.orderId,
token: this.$token,
}).then(data => {
this.showConfirmReceipt = false
if(data.code == 0){
this.showConfirm = true
this.confirmEvent = 'confirmReceipt'
this.confirmText = '立即评价'
this.cancelText = '确定'
this.confirmImg = require('../../assets/images/blueSuccess.png')
this.confirmContent = '确认收货成功'
this.activeItem.orderStatus = '500'
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getOthersOrder (code,cb) {
this.$request.post('/order/queryCodeByUnionCode',{
orderUnionCode: code
}).then(data => {
if(data.code == 0){
cb(data.obj)
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getInvoiceOrders () {
this.$request.post('/order/listOrderBasicByPatch',{
startTime: this.startTime,
endTime: this.endTime,
searchContent: this.invoiceOrderNum
}).then(data => {
console.log(this.selectedItem)
if(data.code == 0){
data.obj.forEach((item, index) => {
item.selected = false
item.showDetail = false
})

this.invoiceOrderList = data.obj.filter((item, index) => {
if(this.selectedItem.orderUnionCode != null){
return this.selectedItem.orderUnionCode != item.orderUnionCode
}else{
return item.orderCode != this.selectedItem.orderCode
}
})

}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
checkedOthersOrders (item, index) {
console.log(JSON.parse(JSON.stringify(item)))
if(item.orderUnionCode != null){
this.invoiceOrderList.forEach((item2, index2) => {
if(item2.orderUnionCode == item.orderUnionCode){
item2.selected = item.selected
}
})
}
},
getInvoiceOrdersDetail (id,item) {
this.$request.post('/order/listOrderDetailByOrderId',{
orderId: id,
}).then(data => {
if(data.code == 0){
item.invoiceOrderDetailDatas = data.obj
item.showDetail = true
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
evaluate (item, index) {    //评价
this.$router.push({
path: '/evaluate',
query: {
orderId: item.orderId
}
})
},
supplementalInvoice (item, index) {
this.selectedItem = item
this.selectedOrderCode = ''
if(item.orderUnionCode != null){
this.$request.post('/order/queryCodeByUnionCode',{
orderUnionCode: item.orderUnionCode,
}).then(data => {
if(data.code == 0){
for(let i=0; i<data.obj.length; i++){
if(data.obj[i].orderStatus > 450){
this.selectedOrderCode += data.obj[i].orderCode+','
}else{
this.isNotReceiveTheGoods = true
this.notReceiveTheGoodsCode = data.obj[i].orderCode
return false;
}
}
this.showSupplementalInvoice = true
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else{
this.selectedOrderCode = item.orderCode+','
this.showSupplementalInvoice = true
}
console.log(JSON.parse(JSON.stringify(item)))
},
selectedInvoiceType (key) {
console.log(key)
if(key == 'withOthers'){
this.startTime = ''
this.endTime = ''
this.invoiceOrderNum = ''
this.showInvoiceOrderList = true
this.getInvoiceOrders()
}else if(key == 'single'){
this.$router.push({
path: '/supplementalInvoice',
query: {
ordreCode: this.selectedOrderCode
}
})
}
},
closeInvoiceOrderDialog () {
this.showSupplementalInvoice = true
this.showInvoiceOrderList = false
},
selectedInvoiceOrderList () {

let str = ''
this.invoiceOrderList.forEach((item, index) => {
if(item.selected){
str += item.orderCode+','
}
})
str += this.selectedOrderCode

this.$router.push({
path: '/supplementalInvoice',
query: {
ordreCode: str
}
})

console.log(str)
},
invoiceOrderDetail (item, index) {
console.log(JSON.parse(JSON.stringify(item)))
if(item.showDetail){
item.showDetail = !item.showDetail
}else{
this.getInvoiceOrdersDetail(item.id,index)
}
},
clearStartTime () {
this.startTime = ''
},
clearEndTime () {
this.endTime = ''
},
searchInvoiceOrder () {
this.getInvoiceOrders()
},
orderDetail (item, index) {   //订单详情
this.$router.push({
path: '/orderDetail',
query: {
orderId: item.orderId,
orderCode: item.orderCode,
boolInvoice: item.boolInvoice
}
})
},

onConfirm () {
if(this.confirmEvent == 'cancelOrder'){   //确定取消订单
this.$request.post('/order/cancelOrder',{
orderId: this.activeItem.orderId,
token: this.$token,
}).then(data => {
if(data.code == 0){
this.$vux.toast.show({
type: 'success',
text: '订单已取消'
})
if(this.activeItem.orderUnionCode != null){
this.list.map((item, index) => {
if(item.orderUnionCode == this.activeItem.orderUnionCode){
item.orderStatus = '100'
}
return item
})
}else{
this.list[this.activeIndex].orderStatus = '100'
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else if(this.confirmEvent == 'applicationForDrawback'){   //确定申请退款
this.$request.post('/order/applyRefund',{
orderId: this.activeItem.orderId,
token: this.$token,
}).then(data => {
if(data.code == 0){
this.$vux.toast.show({
type: 'success',
text: '已申请退款'
})
if(this.activeItem.orderUnionCode != null){
this.list.map((item, index) => {
if(item.orderUnionCode == this.activeItem.orderUnionCode){
item.orderStatus = '200'
}
return item
})
}else{
this.list[this.activeIndex].orderStatus = '200'
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else if(this.confirmEvent == 'applicationForDrawbackCantRefund'){ //不允许退款

}else if(this.confirmEvent == 'confirmReceipt'){   //立即评价

if(this.activeItem.orderType != '商城'){
this.$vux.toast.show({
type: 'warn',
text: '该类型订单不支持评价'
})
}else{
this.$router.push({
path: '/evaluate',
query: {
orderId: this.activeItem.orderId
}
})
}
}
},
onCancel () {
console.log('取消')
if(this.confirmEvent == 'confirmReceipt'){

}
},
},
mounted () {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.loadMore()
},
created() {

console.log(this.$route.query.orderStatus)
this.orderStatus = this.$route.query.orderStatus
},
}



// WEBPACK FOOTER //
// ./src/views/myOrder/script.js